<template>
    <MainCard small-logo>
        <div class="text-center headline font-weight-bold mb-10">
            {{ $t("Let’s setup your company") }}
        </div>
        <v-row no-gutters justify="center">
            <text-field
                :value="controller.model.getCompanyName()"
                autofocus
                :label="$t('Name of your company') + ' *'"
                :error-messages="controller.model.getCompanyNameError()"
                @input="controller.setCompanyName($event)"
            />
        </v-row>
        <v-row no-gutters justify="start" class="mt-6">
            <v-col>
                <span class="title font-weight-bold">
                    {{ $t("Size of your team?") + ' *' }}
                </span>
                <div style="transform: translateY(-12px)">
                    <text-field
                        :value="controller.model.getCompanyTeamSize()"
                        :error-messages="controller.model.getCompanyTeamSizeError()"
                        @keypress="filterNumber"
                        @input="controller.setCompanyTeamSize($event)"
                    />
                </div>
            </v-col>
        </v-row>
        <v-row no-gutters justify="start" class="mb-5 mt-2">
            <v-col cols="12">
                <span class="title font-weight-bold">{{ $t("Which software are you using?") }}</span>
            </v-col>
            <v-col cols="12" class="mb-3">
                <div class="body-2 n3--text">{{ $t("This knowledge will help us to improve Uku") }}</div>
            </v-col>
            <v-col
                v-for="(software, index) in controller.model.getSoftwareOptions()"
                :key="index"
                cols="6"
                class="py-1"
            >
                <checkbox
                    class="mt-0"
                    :value="controller.model.getUsingSoftware().find(x => x === software) !== undefined"
                    :label="software"
                    @change="controller.toggleSoftwareSelect(software)"
                />
            </v-col>
            <v-col cols="12" class="mt-5">
                <text-field
                    :value="controller.model.getOtherSoftware()"
                    :label="$t('What other software needs to be integrated?')"
                    @input="controller.setOtherSoftware($event)"
                />
            </v-col>
        </v-row>
        <v-row justify="end" no-gutters>
            <v-btn id="GTM_SAVE_COMPANY" color="primary" class="white--text w-100" :loading="loader.isLoading" @click="onNextClick">
                <span id="GTM_SAVE_COMPANY">{{ $t("Next") }}</span>
                <v-icon id="GTM_SAVE_COMPANY" right>mdi-arrow-right</v-icon>
            </v-btn>
        </v-row>
    </MainCard>
</template>

<script>
import {$t} from "../../i18n";
import AccountModule from "../../store/modules/account";
import router from "../../router";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import {filterNumber} from "@/helpers/helpers";
import Controller from "@/views/SetupWizard/controller";
import Loader from "@/utility/loader";
import {reactive} from "@vue/composition-api";
import MainCard from "@/components/MainCard/Index";
import {uku_send_event, UKU_ACTIVITIES} from "@/helpers/uku_activity";


export default {
    name: "SetupCompany",
    components: {MainCard},
    props: {
        controller: {
            type: Controller,
            required: true
        }
    },
    setup(props) {
        const loader = reactive(new Loader());
        const {current_account, postProfile, setSettings} = AccountModule();

        if(current_account.value?.xero_company?.name && !props.controller.model.getCompanyName()) {
            props.controller.setCompanyName(current_account.value.xero_company.name)
            props.controller.toggleSoftwareSelect("Xero")
        }

        const onNextClick = () => {
            props.controller.validateCompanyForm()
            if (!props.controller.model.isCompanyFormValid()) {
                return
            }
            loader.withLoader(async () => {
                try {
                    await postProfile(props.controller.model.getCompanyForm());
                    await setSettings(current_account.value.id, {setup_company: 1})

                    await uku_send_event({event: UKU_ACTIVITIES.COMPANY_CREATED, info: "SetupCompany.onNextClick"})

                    router.push({name: "setup_book_demo"});
                } catch (err) {
                    errorDialog.showError(err)
                }
            })
        };
        return {
            onNextClick,
            filterNumber,
            loader
        };
    }
};
</script>
